import { SitemapNode } from "@salaxy/core";

/** The default sitemap tree for Company accounts / users. */
export const sitemap_Company: SitemapNode[] = [
  {
    url: "#/",
    id: "home",
    roles: "company",
    i18n: ["SALAXY.NG1_Pages.Home", "SALAXY.NG1.WorkerListComponent", "SALAXY.NG1.WelcomeComponent", "SALAXY.NG1.SigningComponent", "SALAXY.NG1.ContactInfoComponent"],
    params: {
      features: {
        title: "Features",
        type: "array",
        default: ["welcome", "workerList", "contact"],
        items: {
          type: "string",
          enum: ["welcome", "workerList", "messages", "contact"]
        }
      },
      newCalcDisabled: {
        title: "Palkanmaksu estetty",
        type: "boolean",
      },
      newMessageThreadDisabled: {
        title: "Uuden viestiketjun luonti estetty",
        type: "boolean",
      },
    }
  },
  {
    url: "#/calc",
    id: "calculations",
    i18n: ["SALAXY.NG1.CalcListComponent.panel"],
    roles: "company",
    children: [
      {
        url: "#/calc",
        id: "index",
      },
      {
        url: "#/payroll",
        id: "payroll",
        isFullWidth: true,
        children: [
          {
            url: "#/payroll/details/*",
            visibility: "hidden",
            id: "details",
            params: {
              actions: {
                title: "Readonly actions",
                type: "array",
                default: [],
                items: {
                  type: "string",
                  enum: ["none", "copy", "pay", "cancel"],
                }
              }
            }
          },
          {
            url: "#/payroll/import/*",
            visibility: "hidden",
            id: "import",
            isFullWidth: true,
          }
        ],
      },
      {
        url: "#/calc/details/*/new-for-worker",
        visibility: "hidden",
        id: "newForWorker",
      },
      {
        url: "#/calc/details/*/copy-as-new",
        visibility: "hidden",
        id: "copyAsNew",
      },
      {
        url: "#/calc/details/*",
        visibility: "hidden",
        id: "details",
        i18n:["SALAXY.NG1.CalcComponent","SALAXY.NG1.CalcNewIntroComponent", "SALAXY.NG1.CalcDetailsDialogComponent",  "SALAXY.NG1.CalcDetailsWorkerComponent", "SALAXY.NG1.CalcWorktimeComponent", "SALAXY.NG1.CalcDetailsWorktimeProComponent",  "SALAXY.NG1.CalcDetailsSalaryComponent", "SALAXY.NG1.CalcDetailsExpensesComponent","SALAXY.NG1.CalcRowsComponent", "SALAXY.NG1.CalcResultsComponent", "SALAXY.NG1.CalcChartComponent", "SALAXY.NG1.CalcReportsComponent"],
      },
      {
        url: "#/calc/repair/*",
        visibility: "hidden",
        isFullWidth: true,
        id: "details",
        i18n:["SALAXY.NG1.CalcComponent","SALAXY.NG1.CalcNewIntroComponent", "SALAXY.NG1.CalcDetailsDialogComponent",  "SALAXY.NG1.CalcDetailsWorkerComponent", "SALAXY.NG1.CalcWorktimeComponent", "SALAXY.NG1.CalcDetailsWorktimeProComponent",  "SALAXY.NG1.CalcDetailsSalaryComponent", "SALAXY.NG1.CalcDetailsExpensesComponent","SALAXY.NG1.CalcRowsComponent", "SALAXY.NG1.CalcResultsComponent", "SALAXY.NG1.CalcChartComponent", "SALAXY.NG1.CalcReportsComponent"],
      },
      {
        url: "#/calc/paid",
        id: "paid",
        roles: "company&&!repairs",
        i18n:["SALAXY.NG1.CalcListComponent"]
      },
      {
        url: "#/calc/paid-ir",
        id: "paid-ir",
        roles: "company&&repairs",
        i18n:["SALAXY.NG1.CalcListComponent"]
      },
      {
        url: "#/calc/draft",
        id: "draft",
        i18n:["SALAXY.NG1.CalcListComponent"]
      },
      {
        url: "#/calc/shared",
        id: "shared",
        i18n:["SALAXY.NG1.CalcListComponent"]
      },
      {
        url: "#/calc/repairs",
        id: "repairs",
        roles: "company&&repairs",
        i18n:["SALAXY.NG1.CalcListComponent"]
      },
      {
        url: "#/invoices/sepa",
        isFullWidth: true,
        id: "sepaInvoices",
        roles: "sepaPartner",
      },
      {
        url: "#/invoices/company",
        id: "companyInvoices",
        roles: "test",
      },
      {
        title:"Maksetun laskelman muokkaus",
        url: "#/calc/editor/*",
        visibility: "hidden",
        isFullWidth: true,
        id: "editor",
      },
      {
        url: "#/calc/import-calcs",
        id: "importCalcs",
        isFullWidth: true,
        roles: "test",
      },
      {
        url: "#/invoices/payment-list",
        title: "Maksulista",
        isFullWidth: true,
        id: "paymentList",
        roles: "test||invoicePaymentList",
      },
    ],
  },
  {
    url: "#/payroll",
    id: "payroll",
    roles: "company",
    visibility: "hidden",
    i18n: ["SALAXY.NG1.PayrollComponent.payrollList"],
    children: [
      {
        url: "#/payroll/details/*",
        visibility: "hidden",
        id: "payrollDetails",
        i18n: ["SALAXY.NG1.PayrollComponent.payrollEdit", "SALAXY.NG1.PayrollComponent.payrollCalcs"],
      },
      {
        url: "#/payroll/import/*",
        visibility: "hidden",
        id: "import",
        isFullWidth: true,
      }
    ],
  },
  {
    id: "messages",
    url: "#/messages",
    roles: "partnerMessaging",
    children: [
      {
      url: "#/messages",
      id: "index",
      i18n:["SALAXY.NG1.ActionButtonComponent.startNewMessage","SALAXY.NG1_Pages.Messages.newMessage.title", "SALAXY.NG1_Pages.Messages.newMessage.description.html"]
    },
    {
      id: "omapalkka",
      url: "#/messages/omapalkka",
      title: "Omapalkka",
      roles: "test",
      isFullWidth: true,
    },
    {
      title: "Hyväksyntä",
      url: "#/messages/approval-list",
      id: "approval",
      visibility: "hidden",
      children: [{
        title: "Hyväksy / hylkää",
        url: "#/messages/approval/*",
        visibility: "hidden",
        isFullWidth: true,
        id: "details",
      }],
    },
    {
      url: "#/messages/details/new",
      id: "new",
      i18n: ["SALAXY.NG1_Pages.Messages.newMessageDetails.title","SALAXY.NG1_Pages.Messages.newMessageDetails.description.html"]
    },
    {
      url: "#/messages/details/*",
      visibility: "hidden",
      id: "details",
    }],
  },
  {
    url: "#/workers",
    id: "workers",
    roles: "company",
    children: [
      {
        url: "#/workers",
        id: "index",
        params: {
          hidden: {
            title: "Parts to hide from page",
            type: "array",
            default: [],
            items: {
              type: "string",
              enum: ["workers.employments.records.badge", "workers.employments.taxCard", "workers.employments.buttons.newCalc", "workers.employments.employmentId"]
            }
          }
        }
      },
      {
        url: "#/employments",
        visibility: "hidden",
        id: "employments",
        children: [
          {
            url: "#/employments/index",
            id: "index",
            visibility: "hidden",
          },
        ]
      },
      {
        url: "#/employments/details/*",
        visibility: "hidden",
        id: "details",
        i18n:["SALAXY.NG1.WorkerDetailsComponent", "SALAXY.NG1.WorkerHolidaysComponent", "SALAXY.NG1.WorkerAbsencesComponent"],
        params: {
          features: {
            title: "Features",
            type: "array",
            default: ["detailsEdit", "employment", "calcRows", "calculations", "taxcards", "holidays", "absences"],
            items: {
              type: "string",
              enum: ["detailsEdit", "employment", "calcRows", "calculations", "taxcards", "holidays", "absences"],
            }
          },
          hidden: {
            title: "Parts to hide from page",
            type: "array",
            default: [],
            items: {
              type: "string",
              enum: ["detailsEdit", "employment", "calcRows", "calculations", "taxcards", "holidays", "absences", "employments.defaultCalcRows.features", "employments.calcs.copyAsNew"]
            }
          }
        },
      },
      {
        url: "#/workers/details/*",
        visibility: "hidden",
        id: "workerDetails",
        i18n:["SALAXY.NG1.WorkerDetailsComponent", "SALAXY.NG1.WorkerHolidaysComponent", "SALAXY.NG1.WorkerAbsencesComponent"],
        params: {
          features: {
            title: "Features",
            type: "array",
            default: ["detailsEdit", "employment", "calcRows", "calculations", "taxcards", "holidays", "absences"],
            items: {
              type: "string",
              enum: ["detailsEdit", "employment", "calcRows", "calculations", "taxcards", "holidays", "absences"],
            }
          },
        },
      },
      {
        url: "#/workers/taxcards",
        id: "taxcards",
        i18n:["SALAXY.NG1_Pages.Workers.Taxcards.lead"]
      },
      {
        title: "Lisää työntekijätili",
        url: "#/partners/assure-worker-account",
        id: "assureWorkerAccount",
        isFullWidth: true,
        roles: "assureWorkerAccount",
      },
      {
        url: "#/workers/import-workers",
        id: "importWorkers",
        isFullWidth: true,
        roles: "test",
      },
    ],
  },
  {
    url: "#/reports/holidays",
    id: "worktime",
    isFullWidth: true,
    roles: "company&&!disableHolidays",
    children: [
      {
        id: "holidays",
        url: "#/reports/holidays",
        isFullWidth: true,
      },
      {
        id: "absences",
        url: "#/reports/absences",
        isFullWidth: true,
      },
    ],
  },
  {
    url: "#/reports",
    id: "reports",
    roles: "company",
    children: [
      {
        url: "#/reports",
        id: "index",
        i18n: ["SALAXY.NG1_Pages.Reports.latestReports", "SALAXY.NG1.SalaryReportsComponent.calculations","SALAXY.NG1.SalaryReportsComponent.noCalculations", "SALAXY.NG1.AccountingReportsComponent.accountingReports","SALAXY.NG1.AccountingReportsComponent.noAccountingReports", "SALAXY.NG1.InvoicesComponent.invoices", "SALAXY.NG1.InvoicesComponent.noInvoices"],
        params: {
          features: {
            title: "Features",
            type: "array",
            default: ["salaryReportList", "accountingReportList"],
            items: {
              type: "string",
              enum: ["salaryReportList", "accountingReportList", "invoiceList"],
            }
          },
        },
      },
      {
        url: "#/accounting",
        id: "accounting",
        isFullWidth: true,
        children: [{
            url: "#/accounting/details/*",
            isFullWidth: true,
            id: "details",
            hidden:true,
          }],
      },
      {
        url: "#/accounting/query",
        isFullWidth: true,
        id: "accountingQuery",
        visibility: "hidden",
      },
      {
        url: "#/accounting/holiday-pay-debt-query",
        isFullWidth: true,
        id: "accountingHolidayPayDebtQuery",
        visibility: "hidden",
      },
      {
        url: "#/reports/salary-reports",
        id: "salaryReports",
      },
      {
        url: "#/reports/summary-report-query",
        isFullWidth: true,
        id: "summaryReportQuery",
      },
      {
        url: "#/reports/yearly-summary",
        id: "yearlySummary",
        i18n:["SALAXY.NG1_Pages.Reports.yearlySummary","SALAXY.NG1_Pages.Reports.yearlyTitle"],
      },
      {
        url: "#/reports/pay-certificate",
        roles: "pro",
        id: "payCertificate",
      },
      {
        url: "#/reports/accounting-legacy",
        // id: "accountingLegacy",
        i18n:["SALAXY.NG1_Pages.Reports.accountingIntro","SALAXY.NG1_Pages.Reports.accountingMonthly", "SALAXY.NG1_Pages.Reports.accountingYearly", "SALAXY.NG1_Sitemap.reports.archive"],

        title:"SALAXY.NG1_Sitemap.personalWeb.archive.main" // TODO: fix the id and translation
      },
      {
        url: "#/reports/archive-2018",
        id: "archive",
        visibility: "hidden",
      },
      {
        url: "#/reports/ad-hoc-list",
        id: "ad-hoc",
        roles: "pro,test",
        children: [
          {
            url: "#/reports/ad-hoc/*",
            isFullWidth: true,
            visibility: "hidden",
            id: "details",
          },
        ],
      },
      {
        url: "#/invoices",
        title:"Maksut",
        id: "invoices",
        visibility: "hidden",
        children: [
          {
            url: "#/invoices/details/*",
            visibility: "hidden",
            id: "details",
            title:"Maksun tiedot",
            i18n:["SALAXY.NG1_Pages.Invoices"],
            params: {
              features: {
                title: "Tabs",
                type: "array",
                default: ["preview", "calc"],
                items: {
                  type: "string",
                  enum: ["preview", "calc", "printAndBarCode", "actions"]
                }
              },
            }
          },
        ],
      },
      {
        url: "#/reports/holiday-report",
        id: "holidayReport",
        visibility: "visible",
        isFullWidth: true,
      },
      {
        url: "#/reports/holiday-pay-report-query/*",
        isFullWidth: true,
        id: "holidayPayReportQuery",
        visibility: "hidden",
      },
      {
        url: "#/reports/pay-stats-report-query/*",
        isFullWidth: true,
        id: "payStatsReportQuery",
        visibility: "hidden",
      },
      {
        url: "#/irepr",
        id: "irepr",
        roles: "test",
        children: [{
          url: "#/irepr/details/*",
          id: "details"
        }],
      },
      {
        url: "#/irpsr",
        id: "irpsr",
        roles: "test",
        children: [{
          url: "#/irpsr/details/*",
          id: "details",
        }],
      },
    ],
  },
  {
    url: "#/settings",
    id: "settings",
    roles: "company",
    children: [
      {
        url: "#/settings",
        id: "index",
        params: {
          features: {
            title: "Features",
            type: "array",
            default: ["account", "insurances", "accountant", "paymentChannels"],
            items: {
              type: "string",
              enum:  ["account", "insurances", "accountant", "paymentChannels"],
            }
          }
        },
      },
      {
        url: "#/settings/payment-settings",
        id: "paymentSettings",
        i18n: [ "SALAXY.NG1.PaymentSettingsComponent"],

      },
      {
        url: "#/settings/insurances",
        id: "insurances",
        i18n: [ "SALAXY.NG1.InsuranceSettingsComponent"],
      },
      {
        url: "#/settings/row-types-settings",
        roles: "test",
        id: "rowTypesSettings",
      },
      {
        url: "#/settings/payment-channel-settings",
        id: "paymentChannelSettings",
      },
      {
        url: "#/settings/accounting-target-settings",
        id: "accountingTargetSettings",
      },
      {
        url: "#/settings/owner-settings",
        id: "ownerSettings",
      },
      {
        url: "#/settings/service-settings",
        id: "serviceSettings",
      },
      {
        url: "#/settings/records",
        id: "records",
        visibility: "hidden",
      },
      {
        url: "#/settings/authorizations",
        id: "authorizations",
      },
      {
        id: "accountants",
        url: "#/settings/accountants",
        roles: "company",
        i18n:["SALAXY.NG1.AccountantComponent","SALAXY.NG1.AccountantSelectionComponent"],
        params: {
          "accountantRemovalDisabled": {
            title: "Tilitoimiston poistaminen estetty",
            type: "boolean",
          }
        }
      },
      {
        id: "integrations",
        url: "#/settings/integrations",
      },
      {
        id: "accountReset",
        url: "#/settings/account-reset",
        roles: "test",
      },
      {
        id: "paymentChannel",
        url: "#/payment-channel",
        visibility: "hidden",
      },
    ],
  },
  {
    url: "#/service-models/index",
    id: "pro-service",
    roles: "test&&company",
    children: [
      {
        url: "#/service-models/details/*",
        id: "details",
        visibility: "hidden",
        isFullWidth: true,
      },
      {
        url: "#/settings/pro-settings",
        id: "proSettings",
      },
      {
        id: "usecases",
        url: "#/usecases",
        children: [
          {
            id: "details",
            url: "#/usecases/details/*",
            isFullWidth: true,
          }
        ]
      },
      {
        id: "worktime-imports",
        url: "#/worktime-imports",
        isFullWidth: true,
        children: []
      },
      {
        id: "datasets",
        title: "Datasets",
        url: "#/datasets",
        children: [
          {
            id: "details",
            title: "Dataset",
            url: "#/datasets/details/*",
            isFullWidth: true,
          }
        ]
      },
      {
        id: "calendar",
        url: "#/calendar",
        children: [
          {
            id: "details",
            url: "#/calendar/details/*",
          }
        ]
      },
      {
        url: "#/accounting-targets",
        id: "accountingTargets",
        children: [{
          url: "#/accounting-targets/details/*",
          isFullWidth: true,
          id: "details",
        }]
      },
      {
        url: "#/customer-invoices",
        id: "customerInvoices",
        children: [{
          url: "#/customer-invoices/details/*",
          isFullWidth: false,
          id: "details",
        }]
      },
    ],
  },
  {
    url: "#/info", // info
    id: "info",
    children: [
      {
        url: "#/info",
        id: "index",
        hidden:true,
        i18n:["SALAXY.NG1_Pages.Info", "SALAXY.NG1.ContactInfoComponent"],
        params: {
          "hideButtons": {
            title: "Piilota palkkaus.fi-napit",
            type: "boolean",
          },
          "hideContactInfo": {
            title: "Piilota Aspan yhteystiedot",
            type: "boolean",
          },
        },
      },
      {
        url: "#/info/abc", // temporary fallback
        id: "abc",
        visibility: "hidden",
      }
    ],
  },
];